/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import {
  CONVERT_SMILES_TO_MOL_START,
  CONVERT_SMILES_TO_MOL_FULFILL,
  CONVERT_SMILES_TO_MOL_REJECT,
  CONVERT_SMILES_TO_MOL_RESET_ERROR,
  CONVERT_MOLFILE_TO_MOL_START,
  CONVERT_MOLFILE_TO_MOL_FULFILL,
  CONVERT_MOLFILE_TO_MOL_REJECT,
  CONVERT_MOLFILE_TO_MOL_RESET_ERROR,
  CONVERT_MOL_TO_SMILES_START,
  CONVERT_MOL_TO_SMILES_FULFILL,
  CONVERT_MOL_TO_SMILES_REJECT,
  CONVERT_MOL_TO_SMILES_RESET_ERROR,
  GET_PUBCHEM_MOL_START,
  GET_PUBCHEM_MOL_FULFILL,
  GET_PUBCHEM_MOL_REJECT,
  GET_PUBCHEM_MOL_RESET_ERROR,
} from './molecule-util.actions';

const defaultState = {
  processing: 0,
  error: {
    molToSmiles: null,
    smilesToMol: null,
    nameToMol: null,
    molfileToMol: null,
  },
  data: {},
  molsBySmiles: {},
  molsByName: {},
  molsByMolfiles: {},
};

export default produce((draft: any, action: any = {}) => {
  switch (action.type) {
    case CONVERT_SMILES_TO_MOL_START: {
      ++draft.processing;
      return draft;
    }

    case CONVERT_SMILES_TO_MOL_FULFILL: {
      --draft.processing;
      draft.error.smilesToMol = null;
      draft.data[action.parent.payload.id] = {
        smiles: action.parent.payload.smiles,
        mol: action.payload.result,
      };
      draft.molsBySmiles[action.parent.payload.smiles] = action.payload.result;
      return draft;
    }

    case CONVERT_SMILES_TO_MOL_REJECT: {
      --draft.processing;
      draft.error.smilesToMol = action.payload;
      return draft;
    }

    case CONVERT_SMILES_TO_MOL_RESET_ERROR: {
      draft.error.smilesToMol = null;
      return draft;
    }

    case CONVERT_MOLFILE_TO_MOL_START: {
      ++draft.processing;
      return draft;
    }

    case CONVERT_MOLFILE_TO_MOL_FULFILL: {
      --draft.processing;
      draft.error.molfileToMol = null;
      draft.molsByMolfiles[action.parent.payload.molfile] = action.payload.result;
      return draft;
    }

    case CONVERT_MOLFILE_TO_MOL_REJECT: {
      --draft.processing;
      draft.error.molfileToMol = action.payload;
      return draft;
    }

    case CONVERT_MOLFILE_TO_MOL_RESET_ERROR: {
      draft.error.molfileToMol = null;
      return draft;
    }

    case CONVERT_MOL_TO_SMILES_START: {
      ++draft.processing;
      return draft;
    }

    case CONVERT_MOL_TO_SMILES_FULFILL: {
      --draft.processing;
      draft.error.molToSmiles = null;
      draft.data[action.parent.payload.id] = {
        smiles: action.payload.result,
        mol: action.parent.payload.mol,
      };
      return draft;
    }

    case CONVERT_MOL_TO_SMILES_REJECT: {
      --draft.processing;
      draft.error.molToSmiles = action.payload;
      return draft;
    }

    case CONVERT_MOL_TO_SMILES_RESET_ERROR: {
      draft.error.molToSmiles = null;
      return draft;
    }

    case GET_PUBCHEM_MOL_START: {
      ++draft.processing;
      return draft;
    }

    case GET_PUBCHEM_MOL_FULFILL: {
      --draft.processing;
      draft.error.nameToMol = null;
      draft.molsByName[action.payload.params.nameOrCas] = action.payload.result;
      return draft;
    }

    case GET_PUBCHEM_MOL_REJECT: {
      --draft.processing;
      draft.error.nameToMol = action.payload;
      return draft;
    }

    case GET_PUBCHEM_MOL_RESET_ERROR: {
      draft.error.nameToMol = null;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
